import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-action-list-item.css';

var getClassNameList = classNames.bind(styles);
var UitkActionList = function (props) {
    var _a;
    var border = props.border, className = props.className, children = props.children, cornerRadius = props.cornerRadius, attr = __rest(props, ["border", "className", "children", "cornerRadius"]);
    var baseCssClass = 'uitk-action-list';
    var cssClassNames = getClassNameList(baseCssClass, className, (_a = {},
        _a["".concat(baseCssClass, "-has-border")] = border,
        _a["".concat(baseCssClass, "-has-corners")] = cornerRadius,
        _a));
    return (React.createElement("ul", __assign({ className: cssClassNames }, attr), children));
};
UitkActionList.displayName = 'UitkActionList';

export { UitkActionList };
